import { Injectable, NgZone } from '@angular/core';
import { UserService } from '@app/app-state/user.service';
import { environment } from '@environments/environment';

declare global {
	interface Window {
		ZohoDeskAsap: any;
		ZohoDeskAsapReady: (callback:()=>void)=>void;
		ZohoDeskAsap__asyncalls: Array<()=>void>;
		ZohoDeskAsapReadyStatus: boolean;
		ZohoDeskAsapInit: ()=>{};
	}
}

@Injectable({
	providedIn: 'root',
})
export class SupportButtonService{
	private isHidden=false;
	private isOpen=false;
	private zohoAsapReady=false;
	public get initialized(){return this.zohoAsapReady}
	public get visible(){return !this.isHidden}

	constructor(
		private readonly userService: UserService,
		private readonly ngZone:NgZone
	){
		if(environment.vendor === 'Strayos'){
			this.initializeZohoDeskAsap();
		}
	}

	private initializeZohoDeskAsap(){
		window.ZohoDeskAsapReady=(callback)=>{
			const asyncCalls=window.ZohoDeskAsap__asyncalls=window.ZohoDeskAsap__asyncalls||[];
			if(window.ZohoDeskAsapReadyStatus){
				if(callback)
					asyncCalls.push(callback);
				
				asyncCalls.forEach((cb)=>{
					if(cb) cb();
				});
				window.ZohoDeskAsap__asyncalls=null;
			}else{
				if(callback)
					asyncCalls.push(callback);
			}
		}

		window.ZohoDeskAsapInit=()=>{
			return {
				hideLauncherIcon: true
			}
		}

		// set up the event listener for forms prefill
		window.ZohoDeskAsapReady(()=>{
			this.ngZone.run(()=>this.zohoAsapReady=true);
			window.ZohoDeskAsap.on("onAppOpen", ()=>{
				const userEmail=this.userService?.user?.email || '';
				const userName=this.userService?.user?.firstName || '' + ' ' + this.userService?.user?.lastName || '';
				const sourceUrl=window.location.href;
				window.ZohoDeskAsap.set("ticket.form.prefillValues", {
					[`${environment.zohoDesk.departmentId}&&&${environment.zohoDesk.layoutId}`]: {
						'contactId': {
							defaultValue: userName
						},
						'email': {
							defaultValue: userEmail
						},
						'cf_source_url': {
							defaultValue: sourceUrl,
							isHidden: true
						}
					}
				});
				this.isOpen=true;
			});

			window.ZohoDeskAsap.on("onAppClose", ()=>{
				this.isOpen=false;
			});
		});

		const script=document.createElement('script');
		script.type='text/javascript';
		script.id='zohodeskasapscript';
		script.defer=true;
		script.src=`https://desk.zoho.com/portal/api/web/asapApp/${environment.zohoDesk.widgetId}?orgId=${environment.zohoDesk.orgId}`;

		document.getElementsByTagName('body')[0].appendChild(script);
	}

	public toggle(){
		window.ZohoDeskAsap?.invoke(this.isOpen?'close':'open');
	}

	public openTicketForm(){
		if(this.isOpen){
			window.ZohoDeskAsap?.invoke("close");
		}else{
			window.ZohoDeskAsap?.invoke("routeTo",{ 
				page:"ticket.form", 
				parameters:{ 
					departmentId:environment.zohoDesk.departmentId, 
					layoutId:environment.zohoDesk.layoutId, 
				}
			});
		}
	}

	public hide(){
		this.isHidden=true;
	}

	public show(){
		this.isHidden=false;
	}
}